import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { CLAPPERBOARD_COLORS } from "@/constants/talentClapperboard";

const styles = StyleSheet.create({
  cell: {
    flex: 1,
    backgroundColor: CLAPPERBOARD_COLORS.cellBackground,
    padding: 16 / 2,
    alignItems: "center",
  },
  label: {
    fontSize: 18 / 2,
    fontWeight: 700,
    opacity: 0.7,
    marginBottom: 8 / 2,
  },
  value: {
    fontSize: 40 / 2,
    fontWeight: 400,
    maxLines: 1,
    textOverflow: "ellipsis",
  },
});

interface DataCellProps {
  label: string;
  value?: string | null;
  flex?: number;
}

export const ClapperboardDataCell = ({ label, value, flex = 1 }: DataCellProps) => {
  return (
    <View style={{ ...styles.cell, flex }}>
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.value}>{value ?? " "}</Text>
    </View>
  );
};
